const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

export const getFullDate = (addDays = 0, returnYear = false) => {
    const date = new Date();
    date.setDate(date.getDate() + addDays);
    const days = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    if (returnYear) {
        return (`${days} de ${month}. ${year}`)
    } else return (`${days} de ${month}`)
    

}


export const getDate = (addDays = 0, addMonths = 0, addYears = 0) => {
    let date = new Date();
    date.setDate(date.getDate() + addDays);
    date.setMonth(date.getMonth() + addMonths);
    date.setFullYear(date.getFullYear() + addYears);

    let day = date.getDate();
    if (day < 10) {
        day.toString();
        day = '0' + day;
    }
    let month = date.getMonth() + 1;
    if (month < 10) {
        month.toString();
        month = '0' + month;
    }
    const year = date.getFullYear();
    return (`${year}-${month}-${day}`);
}

export const rangeDaysDate = (addMonths = 0) => {
    const today = new Date();
    const nextMonth = new Date(today.getFullYear(), today.getMonth() + addMonths, 1); // Primer día del próximo mes
    const lastDay = new Date(nextMonth.getFullYear(), nextMonth.getMonth() + 1, 0); // Último día del próximo mes

    const formatDate = (date) => date.toISOString().split("T")[0]; // Formato YYYY-MM-DD

    return {
        firstDay: formatDate(nextMonth),
        lastDay: formatDate(lastDay),
    };
}

export const daysUntil = (dateString) => {
    const today = new Date();
    const targetDate = new Date(dateString);
    
    // Calcular la diferencia en milisegundos
    const diffTime = targetDate - today;

    // Convertir a días (1 día = 1000ms * 60s * 60m * 24h)
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

export const convertDate = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const fullDate = `${year}-${month}-${day}`;
    return fullDate;
}

/** Returns age in years, or null if date is invalid. */
export const getAgeYears = (date) => {
    if (!date) return null;
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    const today = new Date();
    let age = today.getFullYear() - d.getFullYear();
    const m = today.getMonth() - d.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age--;
    return age;
}

//2021-01-01

//`${year}-${month}-${day}`